import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(6, 4),
    backgroundColor: theme.palette.shades['clr-white-900'],
    border: `1px solid ${theme.palette.neutral['clr-200']}`,
    borderRadius: theme.spacing(2),
    width: '100%',
    boxShadow: `
      0px 4px 4px 0px #CCD4DE1A,
      0px 10px 20px 0px #CCD4DE29,
      0px 0px 4px 0px #CCD4DE`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const QuestionCard = ({ title, question = '' }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant="h6-medium" color="primary.main">
        {title}
      </Typography>
      <Box sx={{ maxHeight: '256px', height: '256px', overflow: 'auto' }}>
        <Typography
          variant="body01-semiBold"
          color="neutral.clr-800"
          dangerouslySetInnerHTML={{ __html: question }}
        >
        </Typography>
      </Box>
    </Box>
  );
};

const FollowUpCard = ({ title, question = '' }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant="h6-medium" color="primary.main">
        {title}
      </Typography>
      <Box sx={{ maxHeight: '81px', height: '81px', overflow: 'auto' }}>
        <Typography
          variant="body01-semiBold"
          color={question ? 'neutral.clr-800' : 'danger.clr-700'}
        >
          {question ?
            question :
            'The interview ended before the interviewer could ask a follow-up question.'}
        </Typography>
      </Box>
    </Box>
  );
};

const Questions4c = ({ challenge, followUps }) => {

  const { question1, question2 } = React.useMemo(() => {
    let question1 = null;
    let question2 = null;

    followUps.forEach(({ question, questionType }) => {
      if (questionType === "follow_up_1") question1 = question.question;
      if (questionType === "follow_up_2") question2 = question.question;
    });

    return { question1, question2 };
  }, [followUps]);

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <Typography variant="h4-medium" color="neutral.clr-900">
        Questions
      </Typography>

      <Box display="flex" gap="12px" width={'100%'}>
        <Box flex={1} width={'60%'}>
          <QuestionCard title="Coding problem" question={challenge?.description} />
        </Box>

        <Box flex={1} display="flex" flexDirection="column" gap="12px" width={'40%'}>
          <FollowUpCard title="Follow up - 1" question={question1} />
          <FollowUpCard title="Follow up - 2" question={question2} />
        </Box>
      </Box>
    </Box>
  );
};

export default Questions4c;
